import type { FilterTemplateProps } from '../../types';
import { useModalFacets, useCategoryFields } from '../template-hooks';
import { useDatasetConfig } from '../../dataset-context';
import { FilterListGroup } from '../filter-list-group';
import { orderFacetItems } from '../facet-label';
import style from '../filter-modal.module.scss';

/**
 * A category's always-visible checkbox lists, one per multi-select-list field.
 * @param {FilterTemplateProps} props The template props.
 * @return {JSX.Element} The lists.
 */
export function MultiSelectListTemplate({
  category,
  formValues,
  onFormChange,
}: FilterTemplateProps) {
  const facets = useModalFacets();
  const fields = useCategoryFields(category, 'multi-select-list');
  const config = useDatasetConfig();

  return (
    <div className={style.fieldStack}>
      {fields.map((field) => (
        <FilterListGroup
          key={field.id}
          id={field.id}
          label={field.label}
          countNoun={config.label}
          facetBuckets={orderFacetItems(
            facets?.[field.facetKey]?.buckets ?? [],
            !!config.alphabeticalFacetOptions
          )}
          selectedIds={(formValues[field.param] as string[] | undefined) ?? []}
          onChange={(ids) =>
            onFormChange(field.param, ids.length > 0 ? ids : undefined)
          }
        />
      ))}
    </div>
  );
}
